/** @file NamedList rename/delete handlers of a rig domain; Rename only when `<domain>.rename` is registered. */
import { lookupCommand } from '@pose2d/commands/lookupCommand';
import type { RunCommands } from './rigView';

/** Domains whose entities the rig panels list by name. */
export type RigDomain = 'skin' | 'event' | 'ik' | 'socket';

/** Rename and delete callbacks for NamedList; `has` is the registry check (injected by tests). */
export interface ListHandlers {
  onRename: ((target: string, name: string) => void) | undefined;
  onDelete: (target: string) => void;
}

const registered = (command: string): boolean => lookupCommand(command) !== undefined;

/** `<domain>.rename { target, name }` (when registered; ik/socket renames are X2's) and `<domain>.delete { target }`. */
export function listHandlers(domain: RigDomain, run: RunCommands, has: (command: string) => boolean = registered): ListHandlers {
  const rename = `${domain}.rename`;
  return {
    onRename: has(rename) ? (target, name) => { run([{ name: rename, input: { target, name } }]); } : undefined,
    onDelete: (target) => { run([{ name: `${domain}.delete`, input: { target } }]); },
  };
}
